import { render, staticRenderFns } from "./TipsAnalysis.vue?vue&type=template&id=523e1e2c&scoped=true&"
import script from "./TipsAnalysis.vue?vue&type=script&lang=js&"
export * from "./TipsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TipsAnalysis.vue?vue&type=style&index=0&id=523e1e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e1e2c",
  null
  
)

export default component.exports